import type { FC } from "react";

import type { Action, ActionAction, Pages, Steps as StepsData } from "~/core";

import { StepsColumn } from "./components/StepsColumn";
import { StepsRow } from "./components/StepsRow";

export type StepsProps = {
  data: StepsData;
  getUrl: (page: Pages) => string;
  onCallAction: (action: ActionAction) => void;
  isControlInactive: (control: Action) => boolean;
};

export const Steps: FC<StepsProps> = (props) => {
  const { data } = props;

  return data.steps_variant === "row" ? (
    <StepsRow {...props} />
  ) : (
    <StepsColumn {...props} />
  );
};
